export default __webpack_public_path__ + "lang/en_US.mo";